<template>
  <v-container fluid fill-height align-start pa-0 class="pageWrap">
    <v-sheet class="contents-container">
      <i-card-vertical headerTitle="일일/순회안전점검 관리" :IsUseEditorBox="true" device="web">
        <template v-slot:EditorBox>
          <date-bar
            :firstDisplayDate="startDate"
            :dateOnly="true"
            class="mx-1"
            label="일자"
            date
            full-width
            no-title
            :allowMaxDate="maxDate"
            :functionEvents="functionEvents"
            @getDate="handleDateChange"
          ></date-bar>
        </template>
        <template v-slot:body>
          <v-sheet class="tab-layout">
            <!-- 좌측 tab -->
            <v-card color="inner_card_bg" class="overflow-y-auto">
              <v-list class="pa-0 contents-menu">
                <v-list-item-group>
                  <v-list-item
                    v-for="(item, index) in tabList"
                    :key="item.index"
                    @click="handleTabClick(index)"
                    :class="{ active: selectedKey === index }"
                  >
                    <v-list-item-content>{{ item.name }}</v-list-item-content>
                  </v-list-item>
                </v-list-item-group>
              </v-list>
            </v-card>

            <!-- 일일 안전점검 -->
            <v-card :class="breakpoint === 'md' || breakpoint === 'sm' || breakpoint === 'xs' ? 'mt-5' : ''">
              <div class="d-flex align-center justify-space-between">
                <div v-if="selectedKey == 0">
                  <span class="editor-subTitle">일자:</span>
                  <span class="editor-title">{{ formattedStartDate }}</span>
                  <span class="mx-2 editor-subTitle btn_outline--text">|</span>
                  <span v-if="dailyCheckList.length > 0" class="editor-subTitle">사업장:</span>
                  <span v-if="dailyCheckList.length > 0" class="editor-title">{{ dailyCheckList[0].compNm }}</span>
                  <span class="mx-2 editor-subTitle btn_outline--text">|</span>
                  <span v-if="dailyCheckList.length > 0" class="editor-title">{{ dailyCheckList[0].korNm ? dailyCheckList[0].korNm : myName }}</span>
                  <span v-if="dailyCheckList.length > 0" class="editor-subTitle">{{
                    dailyCheckList[0].grpAuthNm ? ` (${dailyCheckList[0].grpAuthNm})` : ` (${grpAuthNm})`
                  }}</span>
                </div>
                <div v-else>
                  <span class="editor-subTitle">일자:</span>
                  <span class="editor-title">{{ formattedStartDate }}</span>
                  <span class="mx-2 editor-subTitle btn_outline--text">|</span>
                  <span v-if="dailyCheckList.length > 0" class="editor-subTitle">사업장:</span>
                  <span v-if="dailyCheckList.length > 0" class="editor-title">{{ dailyCheckList[0].compNm }}</span>
                  <span class="mx-2 editor-subTitle btn_outline--text">|</span>
                  <span class="editor-title">{{ circuitSafetyList.length > 0 ? circuitSafetyList[0].korNm : myName }}</span>
                  <span class="editor-subTitle">{{ circuitSafetyList.length > 0 ? ` (${circuitSafetyList[0].grpAuthNm})` : ` (${grpAuthNm})` }}</span>
                </div>
                <v-btn
                  v-show="selectedKey === 0"
                  color="primary"
                  large
                  elevation="0"
                  outlined
                  class="rounded ml-2"
                  @click="ShowPopup('일일 안전점검 양식 관리')"
                  >일일 안전점검 양식 관리</v-btn
                >
              </div>
              <div v-show="selectedKey === 0">
                <div class="d-flex align-center" style="width: 300px">
                  <v-simple-table class="mr-5 custom-table">
                    <template v-slot:default>
                      <colgroup>
                        <col style="width: 120px" />
                        <col style="width: 180px" />
                      </colgroup>
                      <tbody>
                        <tr>
                          <td class="text-center tableTitle required">
                            <v-tooltip right color="primary" max-width="240px">
                              <template v-slot:activator="{ on }">
                                근무 시간
                                <svg-icon icon-class="info" style="height: 1rem" v-on="on" />
                              </template>
                              <div class="tooltip-text">{{ noticeInfo }}</div>
                            </v-tooltip>
                          </td>

                          <td>
                            <v-card width="100%" class="d-flex justify-space-between">
                              <v-text-field type="number" min="3" max="23" solo v-model="hour" suffix="시간" @change="worktimeChanged($event)" />
                              <v-text-field
                                class="mr-2"
                                type="number"
                                min="0"
                                max="59"
                                solo
                                v-model="minute"
                                suffix="분"
                                @change="worktimeChanged($event)"
                              />
                              <!-- <v-text-field style="width: 100%" type="number" min="150" solo v-model="worktime" suffix="분" @change="worktimeChanged($event)"/> -->
                            </v-card>
                          </td>
                        </tr>
                      </tbody>
                    </template>
                  </v-simple-table>
                </div>
                <v-simple-table class="mt-5 custom-table">
                  <template v-slot:default>
                    <tbody>
                      <tr>
                        <td class="text-center tableTitle" style="width: 5%">번호</td>
                        <td class="text-center tableTitle" style="width: 50%">안전점검 항목</td>
                        <td class="text-center tableTitle" style="width: 5%">양호</td>
                        <td class="text-center tableTitle" style="width: 5%">불량</td>
                        <td class="text-center tableTitle" style="width: 35%">비고</td>
                      </tr>

                      <tr v-if="dailyCheckList.length === 0" style="height: 100px">
                        <td colspan="3" class="text-center font-weight-bold" style="color: #ff0000; font-size: 15px">
                          적용된 양식의 안전점검항목이 없습니다. 일일 안전점검 양식 관리 팝업을 통해 항목을 등록하세요.
                        </td>
                      </tr>
                      <tr v-for="(row, index) in dailyCheckList" :key="index">
                        <td class="text-center">{{ row.seq }}</td>
                        <td style="font-size: 1rem">{{ row.safetyInspectionDailyDivItemNm }}</td>
                        <td>
                          <div class="d-flex justify-center align-center">
                            <v-checkbox
                              v-model="row.safetyInspectionDailyYn"
                              :true-value="'Y'"
                              :false-value="'N'"
                              hide-details
                              @click="checkAgree(row)"
                            ></v-checkbox>
                          </div>
                        </td>
                        <td>
                          <div class="d-flex justify-center align-center">
                            <v-checkbox
                              v-model="row.safetyInspectionDailyYn"
                              :true-value="'N'"
                              :false-value="'Y'"
                              hide-details
                              @click="checkAgree(row)"
                            ></v-checkbox>
                          </div>
                        </td>
                        <td>
                          <v-textarea
                            auto-grow
                            v-model="row.safetyInspectionDailyRemark"
                            placeholder="내용을 입력해주세요."
                            solo
                            hide-details="auto"
                          />
                        </td>
                      </tr>
                    </tbody>
                  </template>
                </v-simple-table>
                <!-- 일일점검 파일업로드 -->
                <iFileManage class="mt-5" ref="iFileUploader" id="daily" :targetId="targetId" targetType="00011" @onFileChanged="onFileChanged" />
              </div>
              <!-- 순회안전점검 -->
              <div v-if="selectedKey === 1">
                <!-- 주요점검사항 -->
                <v-form ref="circuitForm" class="mt-5">
                  <v-simple-table :key="componentKey" class="custom-table">
                    <template v-slot:default>
                      <colgroup>
                        <col style="width: 7%" />
                        <col style="width: 33%" />
                        <col style="width: 60%" />
                      </colgroup>
                      <tbody>
                        <tr>
                          <td colspan="3" class="text-center tableTitle">{{ majorList[0].minorNm }}</td>
                        </tr>
                        <tr>
                          <td class="tableTitle text-center"></td>
                          <td class="tableTitle text-center required">이미지</td>
                          <td class="tableTitle text-center required">내용</td>
                        </tr>
                        <tr v-if="isNoData(data00001)" style="height: 100px">
                          <td colspan="3" class="text-center font-weight-bold" style="color: #ff0000; font-size: 15px">
                            {{ `순회안전점검 ${majorList[0].minorNm} 항목이 없습니다. + 버튼을 눌러 항목을 추가하세요.` }}
                          </td>
                        </tr>
                        <template v-for="(item, itemIndex) in data00001">
                          <tr v-if="!item.__deleted__" :key="itemIndex">
                            <td class="text-center" width="2%">
                              <!-- 삭제 버튼 -->
                              <v-btn
                                text
                                @click="removeRow('00001', itemIndex)"
                                height="calc(100% - 24px)"
                                class="rounded-pill pa-2"
                                :color="'error'"
                              >
                                <svg-icon icon-class="minus" style="height: 20px" />
                              </v-btn>
                            </td>
                            <td :key="`component_${item.seq}`">
                              <iImgCellFileManage
                                ref="imgCellFileManage"
                                :seq="item.seq"
                                :imgUrl="item.imgUrl"
                                :created="item.__created__"
                                :targetId="item.targetId"
                                :fileExtension="allowedFileExtensions.join(', ')"
                                targetType="00011"
                              />
                            </td>
                            <td>
                              <v-textarea
                                :rules="rules"
                                auto-grow
                                v-model="item.content"
                                placeholder="내용을 입력해주세요."
                                solo
                                hide-details="auto"
                              />
                            </td>
                          </tr>
                        </template>
                        <!-- 항목 추가-->
                        <tr>
                          <td colspan="3" style="padding: 0 !important">
                            <v-btn elevation="0" @click="addRow('00001')" width="100%" height="48" class="table-add-btn">
                              <svg-icon icon-class="table-add" width="20" height="20" />
                            </v-btn>
                          </td>
                        </tr>
                      </tbody>
                    </template>
                  </v-simple-table>

                  <!-- 주요인적지적사항 -->
                  <v-simple-table class="mt-4 custom-table">
                    <template v-slot:default>
                      <colgroup>
                        <col style="width: 7%" />
                        <col style="width: 33%" />
                        <col style="width: 60%" />
                      </colgroup>
                      <tbody>
                        <tr>
                          <td colspan="3" class="text-center tableTitle">{{ majorList[1].minorNm }}</td>
                        </tr>
                        <tr>
                          <td class="tableTitle text-center"></td>
                          <td class="tableTitle text-center required">이미지</td>
                          <td class="tableTitle text-center required">내용</td>
                        </tr>
                        <tr v-if="isNoData(data00002)" style="height: 100px">
                          <td colspan="3" class="text-center font-weight-bold" style="color: #ff0000; font-size: 15px">
                            {{ `순회안전점검 ${majorList[1].minorNm} 항목이 없습니다. + 버튼을 눌러 항목을 추가하세요.` }}
                          </td>
                        </tr>
                        <template v-for="(item, itemIndex) in data00002">
                          <tr v-if="!item.__deleted__" :key="itemIndex">
                            <td class="text-center" width="2%">
                              <!-- 삭제 버튼 -->
                              <v-btn
                                text
                                @click="removeRow('00002', itemIndex)"
                                height="calc(100% - 24px)"
                                class="rounded-pill pa-2"
                                :color="'error'"
                              >
                                <svg-icon icon-class="minus" style="height: 20px" />
                              </v-btn>
                            </td>
                            <td>
                              <iImgCellFileManage
                                ref="imgCellFileManage"
                                :seq="item.seq"
                                :imgUrl="item.imgUrl"
                                :created="item.__created__"
                                :targetId="item.targetId"
                                :fileExtension="allowedFileExtensions.join(', ')"
                                targetType="00011"
                              />
                            </td>
                            <td>
                              <v-textarea
                                :rules="rules"
                                auto-grow
                                v-model="item.content"
                                placeholder="내용을 입력해주세요."
                                solo
                                hide-details="auto"
                              />
                            </td>
                          </tr>
                        </template>
                        <!-- 항목 추가-->
                        <tr>
                          <td colspan="3" style="padding: 0 !important">
                            <v-btn elevation="0" @click="addRow('00002')" width="100%" height="48" class="table-add-btn">
                              <svg-icon icon-class="table-add" width="20" height="20" />
                            </v-btn>
                          </td>
                        </tr>
                      </tbody>
                    </template>
                  </v-simple-table>

                  <!-- 기타 점검 및 특이사항 -->
                  <v-simple-table class="mt-4 custom-table">
                    <template v-slot:default>
                      <tbody>
                        <tr>
                          <td class="text-center tableTitle" style="width: 10%">{{ majorList[2].minorNm }}</td>
                        </tr>
                        <template>
                          <tr>
                            <td>
                              <v-textarea auto-grow v-model="content" placeholder="내용을 입력해주세요." solo hide-details="auto" />
                            </td>
                          </tr>
                          <tr>
                            <td>
                              <!-- 순회점검 파일업로드 -->
                              <!-- <div class="d-flex justify-center align-center py-2"> -->
                              <iFileManage
                                v-if="selectedKey === 1"
                                ref="iFileUploader_circuit"
                                id="circuit"
                                :targetId="targetId"
                                targetType="00011"
                                @onFileChanged="onFileChanged"
                              />
                              <!-- </div> -->
                            </td>
                          </tr>
                        </template>
                      </tbody>
                    </template>
                  </v-simple-table>
                </v-form>
              </div>
            </v-card>
          </v-sheet>
        </template>
        <template v-slot:drawer>
          <v-navigation-drawer v-model="procedureShow" width="75%" absolute right temporary class="feedback-area">
            <ProcedureComponent :type="'00002'" />
          </v-navigation-drawer>
        </template>
      </i-card-vertical>
      <v-sheet class="iCardRightWrap">
        <i-card-right
          class="d-md-flex"
          :useBtnList="buttonUseList"
          @btnSearch="btnSearch()"
          @btnSave="btnSave()"
          @btnPrint="btnPrint"
          @btnDelete="btnDelete()"
        ></i-card-right>
        <i-card-right>
          <template v-slot:customBtn>
            <i-icon-button color="btn_text" :text="'절차서'" :icon="'file'" @click="procedureShow = !procedureShow"></i-icon-button>
          </template>
        </i-card-right>
      </v-sheet>
      <safety-inspection-detail
        :popupVisible="popupVisible"
        @popupClose="popupClose"
        title="일일 안전점검 양식 관리"
        :itemList="itemList"
        :compId="initCompId"
        @apply="apply"
      />
    </v-sheet>
  </v-container>
</template>
<script>
import iCardTop from '@/components/common/iCardTop.vue'
import iCardVertical from '@/components/common/iCardVertical.vue'
import notify from 'devextreme/ui/notify'
import dateBar from '@/components/common/dateBar.vue'
import baseview from '@/views/base/baseview.vue' //20220414 LYJ base page 추가
import BaseDataGrid from '@/views/base/BaseDataGrid.vue' //20220509 LYJ 데이타 그리드 사용시 베이스 추가
import { AesEncrypt, AesDecrypt } from '@/utils/aes256'
// 일일 안전점검 항목관리
import SafetyInspectionDetail from './SafetyInspectionDetail.vue'
// 파일 업로드 컴포넌트
import iFileManage from '@/components/esgCommon/iFileManage.vue'
import iImgCellFileManage from '@/components/esgCommon/iImgCellFileManage'
// 날짜 형식
import { getCurrentDate, getPreMonth } from '@/utils/common.js'
// 일일점검 조회,저장,삭제 Api
import {
  getSafetyInspectionDivList,
  getSafetyInspection,
  saveSafetyInspection,
  deleteSafetyInspection,
  getRptSafetyInspection,
  getCircuitSafetyInspection,
  saveCircuitSafetyInspection,
  deleteCircuitSafetyInspection,
  deleteCircuitTaskSafetyInspection,
  getRptCircuitSafetyInspection,
  getDailyImplementaionDateList,
  getCircuitImplementaionDateList,
} from '@/api/riskAssessment/safetyInspectionManage'
// 공통코드
import { getCommonCode } from '@/api/common/commonApi'
// 유저정보 Api
import { getUserListInfo } from '@/api/system/userManage'
import ProcedureComponent from '@/views/procedure/components/ProcedureComponent.vue'

export default {
  mixins: [baseview, BaseDataGrid], //20220414 LYJ base page 추가 및 권한 처리
  components: {
    'i-card-vertical': iCardVertical,
    'date-bar': dateBar,
    iFileManage,
    iImgCellFileManage,
    'safety-inspection-detail': SafetyInspectionDetail,
    // 절차서 컴포넌트
    ProcedureComponent,
  },

  data() {
    return {
      rules: [
        (value) => {
          if (value) return true
          return '필수입력 값입니다.'
        },
      ],
      noticeInfo: '최소 근무 시간은 3시간 30분 입니다.',
      // 사업장
      initCompId: '',
      //버튼
      buttonUseList: [
        'btnSearch', //조회
        'btnSave', //저장
        'btnPrint',
        'btnDelete',
      ],
      selectedKey: 0,
      // tab 제목
      tabList: [
        {
          name: '일일 안전점검',
        },
        {
          name: '순회 안전점검',
        },
      ],
      //팝업관련
      popupVisible: false,
      popupHeight: '',
      popupWidth: '',
      popupMinWidth: '',
      popupTitle: '',
      itemList: [],
      // 유저정보
      myHrNo: '',
      myName: '',
      grpAuthNm: '',
      grpAuthCd: '',
      // 일일안전점검 데이터
      hour: 3,
      minute: 30,
      worktime: 210,
      fileList: {
        insert: [],
        delete: [],
      },
      targetId: '',
      targetType: '00011',
      startDate: getCurrentDate(0),
      maxDate: getCurrentDate(0),
      searchStartDate: getCurrentDate(0),
      dailyCheckList: [],
      //순회안전점검 데이터
      majorList: [],
      data00001: [],
      data00002: [],
      data00003: [],
      circuitSafetyList: [],
      deletedList: [],
      content: '',
      imageSrc: [],
      //비동기문제로 componentKey 키 걸어줌
      componentKey: 0,
      allowedFileExtensions: ['.jpg', '.jpeg', '.png'],
      circuitCreated: true, // 순회안전점검 초기문서인지 확인을 위한 플래그 값
      dateList: [],
      interval: null,
      // 절차서 컴포넌트
      procedureContent: '',
      procedureShow: false, // 절차서 보이기
    }
  },
  async created() {
    // console.log('created')
    this.initCompId = this.getCompId() // 초기 페이지 진입 시 compId 세팅
  },
  activated() {
    this.dailyDateList = []
    this.circuitDateList = []
    // console.log('activated')
    if (this.changedCompFlag(this.initCompId)) {
      // 로컬 스토리지에 저장된 값을 비교하여 변경 전 / 변경 후 compId가 다르고,
      // 페이지 진입시 세팅해두었던 compId 와 변경 후 compId와 다를 경우
      this.initCompId = this.getCompId()
      this.btnSearch()
    }
  },
  async beforeMount() {
    // 로그인 유저 정보
    Promise.all([getUserListInfo({ clntId: this.getClntId(), userCd: this.getUserCd() }), getCommonCode('SAFE001')])
      .then((response) => {
        // console.log('정보', response[2])
        let res = response[0]
        if (res.success) {
          this.myHrNo = res.list[0].esgHrNo
          this.myName = res.list[0].korNm
          this.grpAuthCd = res.list[0].grpAuthCd
          this.grpAuthNm = res.list[0].grpAuthNm
        }
        this.majorList = response[1].list
      })
      .then(() => {
        this.btnSearch() // 모든 프로미스가 완료된 후에 btnSearch() 실행
        this.searchStartDate = getCurrentDate(0)
      })
  },
  mounted() {},
  computed: {
    mobileTrigger: function () {
      return this.getWidth() < 1920
    },
    breakpoint() {
      return this.$vuetify.breakpoint.name
    },
    formattedStartDate() {
      return this.searchStartDate.replace(/(\d{4})(\d{2})(\d{2})/, '$1.$2.$3').replaceAll('-', '.')
    },
  },
  methods: {
    isNoData(data) {
      console.log('### ')
      let filteredData = data.filter((el) => !el.__deleted__)
      if (filteredData.length > 0) return false
      else return true
    },
    functionEvents(date) {
      const [year, month, day] = date.split('-')
      if (this.dateList.includes(year + month + day)) return true
      return false
    },
    // 팝업관련
    apply(e) {
      //적용
      this.popupClose()
    },
    //
    handleTabClick(index) {
      if (this.selectedKey != index) {
        this.selectedKey = index
        this.btnSearch()
      }
    },

    addRow(minorCd) {
      // console.log('##item', minorCd)
      if (minorCd === '00001') {
        let prevSeq = this.data00001[this.data00001.length - 2]
        this.data00001.push({
          clntId: this.getClntId(),
          compId: this.getCompId(),
          writeDt: this.searchStartDate,
          seq: this.data00001.length > 0 ? this.data00001[this.data00001.length - 1].seq + 1 : 1,
          esgHrNo: this.circuitSafetyList.length > 0 ? this.circuitSafetyList[0].esgHrNo : this.myHrNo,
          content: '',
          imgUrl: null,
          majorCd: 'SAFE001',
          minorCd: minorCd,
          __deleted__: false,
          __created__: true,
        })
        this.data00001[this.data00001.length - 1].targetId = `${this.getClntId()}_${this.getCompId()}_${this.searchStartDate}_${minorCd}_${
          this.data00001.length
        }`
      } else {
        this.data00002.push({
          clntId: this.getClntId(),
          compId: this.getCompId(),
          writeDt: this.searchStartDate,
          seq: this.data00002.length > 0 ? this.data00002[this.data00002.length - 1].seq + 1 : 1,
          esgHrNo: this.circuitSafetyList.length > 0 ? this.circuitSafetyList[0].esgHrNo : this.myHrNo,
          content: '',
          imgUrl: null,
          majorCd: 'SAFE001',
          minorCd: minorCd,
          __deleted__: false,
          __created__: true,
        })
        this.data00002[this.data00002.length - 1].targetId = `${this.getClntId()}_${this.getCompId()}_${this.searchStartDate}_${minorCd}_${
          this.data00002.length
        }`
      }
    },
    removeRow(minorCd, index) {
      if (minorCd === '00001') {
        this.data00001.forEach((el) => {
          if (el.seq === this.data00001[index].seq) {
            el.__deleted__ = true
          }
        })
        // this.data00001 = this.data00001.filter(el => el.seq != this.data00001[index].seq)
        // this.$refs.imgCellFileManage[index+1].forceRerender()
      } else {
        this.data00002.forEach((el) => {
          if (el.seq === this.data00002[index].seq) {
            el.__deleted__ = true
          }
        })
        // this.data00002 = this.data00002.filter(el => el.seq != this.data00002[index].seq))
      }
    },
    btnPopup() {
      // console.log('예시보기 클릭')
      this.openLoading()
      if (this.selectedKey === 0) {
        // 검색을 위한 매개변수 설정
        this.itemList = []
        // 일일안전점검 데이터
        let params = {
          clntId: this.getClntId(),
          compId: this.initCompId,
        }
        getSafetyInspectionDivList(params, true)
          .then((res) => {
            if (res.success) {
              if (res.list.length > 0) {
                this.itemList = res.list

                console.log('팝업조회', this.itemList)
              }
              this.popupVisible = true
            }
          })
          .finally()
      }
      this.endLoading()
    },
    // 일일 안전점검 항목 관리
    ShowPopup(title) {
      this.btnPopup()
      this.popupTitle = title
      this.popupHeight = '80vh'
      this.popupWidth = '80vw'
      this.popupMinWidth = '460'
    },
    popupClose() {
      this.popupVisible = false
      this.btnSearch()
    },
    //일자 선택
    handleDateChange(val) {
      if (val) {
        this.searchStartDate = val
        this.startDate = this.searchStartDate
      }
      this.btnSearch()
    },
    btnSearch() {
      this.openLoading()
      //일일 안전점검 조회
      if (this.selectedKey === 0) {
        // 검색을 위한 매개변수 설정
        this.searchStartDate = this.searchStartDate.replace(/[^0-9]/g, '')
        this.targetId = this.getClntId() + '_' + this.initCompId + '_' + this.searchStartDate.replaceAll('-', '') + '_' + this.targetType
        // clntId compId writeDt minorCd 00011
        let params = {
          clntId: this.getClntId(),
          compId: this.initCompId,
          writeDt: this.searchStartDate,
        }
        // 일일안전점검 데이터
        getSafetyInspection(params, true)
          .then((res) => {
            this.dailyCheckList = []
            if (res.success) {
              this.$refs.iFileUploader.btnSearch()
              if (res.list.length > 0) {
                this.dailyCheckList = res.list
                if (res.list[0].worktime) {
                  this.worktime = _.clone(res.list[0].worktime)
                  this.hour = Math.floor(this.worktime / 60)
                  this.minute = this.worktime % 60
                } else {
                  this.worktime = 210
                  this.hour = 3
                  this.minute = 30
                }
              }
            }
          })
          .finally()
        getDailyImplementaionDateList(params, false).then((res) => {
          if (res.list.length > 0) {
            this.dateList = _.clone(res.list)
          }
        })
      } else if (this.selectedKey === 1) {
        //순회 안전점검 조회
        this.circuitSearch()
      }
      this.componentKey++
      this.endLoading()
    },
    async circuitSearch() {
      // 검색을 위한 매개변수 설정
      this.content = ''
      this.searchStartDate = this.searchStartDate.replace(/[^0-9]/g, '')
      this.targetId = this.getClntId() + '_' + this.getCompId() + '_' + this.searchStartDate + '_00003_00011'
      let params = {
        clntId: this.getClntId(),
        compId: this.getCompId(),
        writeDt: this.searchStartDate,
      }

      // 순회 안전점검 데이터
      await getCircuitSafetyInspection(params, true)
        .then((res) => {
          if (res.success) {
            console.log('################Res', res)
            this.circuitSafetyList = _.clone(res.list)
            // 초기 문서인지 확인을 위한 플래그값 세팅
            if (res.list.length === 0) this.circuitCreated = true
            // this.fileDownload(res)
            else {
              this.circuitCreated = false
              res.list.forEach((el) => {
                el.__deleted__ = false
              })
            }
            this.data00001 = res.list.filter((el) => el.minorCd === '00001') // 주요점검사항 데이터 세팅
            this.data00002 = res.list.filter((el) => el.minorCd === '00002') // 주요인적지적사항 데이터 세팅
            this.data00003 = res.list.filter((el) => el.minorCd === '00003') // 기타점검 및 특이사항 데이터 세팅
            if (this.data00003.length === 0) {
              this.data00003 = [
                {
                  clntId: this.getClntId(),
                  compId: this.getCompId(),
                  writeDt: this.searchStartDate,
                  majorCd: 'SAFE001',
                  minorCd: '00003',
                  targetId: this.targetId,
                  content: this.content,
                  __created__: true,
                  __deleted__: false,
                },
              ]
            } else {
              this.data00003[0].targetId = this.targetId
            }
            // 기타점검 및 특이사항 데이터 바인딩
            this.content = this.data00003.length > 0 ? this.data00003[0].content : ''
            this.componentKey++
          }
        })
        .finally(() => {
          this.$refs.iFileUploader_circuit.btnSearch()
          if (this.$refs.imgCellFileManage) {
            this.$refs.imgCellFileManage.forEach((el) => {
              el.btnSearch()
            })
          }
          this.componentKey++
        })
      getCircuitImplementaionDateList(params, false).then((res) => {
        if (res.list.length > 0) {
          this.dateList = _.clone(res.list)
        }
      })
    },
    btnSave() {
      if (this.selectedKey === 0) {
        //일일 안전점검 데이터 저장
        // const validate = this.$refs.form.validate()
        // if (!validate) {
        //   this.vToastify(this.$t('저장 입력 항목을 확인해주세요.'), 'warn')
        //   return
        // }
        if (this.dailyCheckList.length === 0) {
          this.vSnackbar(this.$t('저장할 일일 안전점검 항목이 없습니다.'), 'warn')
          return
        }
        if (this.worktime < 210) {
          this.vSnackbar(this.$t(this.noticeInfo), 'warn')
          return
        }
        let saveSuccess = false
        this.vToastifyPrompt(
          this.$t('doSaveData'),
          'info',
          async (current) => {
            this.openLoading()
            let saveData = []
            this.dailyCheckList.forEach((item) => {
              //조회했던 clntId,compId 그대로 dataClntId,dataCompId에 먼저 할당
              item.dataClntId = item.clntId
              item.dataCompId = item.compId
              //
              if (!item.esgHrNo) item.esgHrNo = this.myHrNo
              item.clntId = this.getClntId()
              item.compId = this.initCompId
              item.writeDt = this.searchStartDate
              item.worktime = this.worktime
              if (!item.safetyInspectionDailyYn) {
                item.safetyInspectionDailyYn = null
              }
              saveData.push(item)
            })
            console.log('## saveData', saveData)
            await saveSafetyInspection(saveData, true)
              .then((res) => {
                if (res.success) {
                  saveSuccess = true
                  this.targetId = this.getClntId() + '_' + this.initCompId + '_' + this.searchStartDate + '_' + this.targetType
                  this.writeDt = this.searchStartDate
                }
              })
              .catch((error) => {
                if (error.response && error.response.data) {
                  if (error.response.data.code == -2001) {
                    this.vToastify(this.$t(error.response.data.msg), 'info')
                  }
                }
                this.endLoading()
              })
              .finally(() => {
                //파일 저장
                if (saveSuccess && (this.fileList.insert.length !== 0 || this.fileList.delete.length !== 0)) {
                  this.$refs.iFileUploader.btnSave(this.fileList)
                  this.fileList = {
                    insert: [],
                    delete: [],
                  }
                }
                getDailyImplementaionDateList(saveData[0], false).then((res) => {
                  if (res.list.length > 0) {
                    this.dateList = _.clone(res.list)
                  }
                })
                this.btnSearch()
                this.endLoading()
              })
          },
          null,
          true
        )
      } else if (this.selectedKey === 1) {
        //순회점검 데이터 저장
        const validate = this.$refs.circuitForm.validate()

        if (!validate) {
          this.vToastify(this.$t('저장 입력 항목을 확인해주세요.'), 'info')
          return
        }
        this.circuitSave()
      }
    },
    //순회 저장
    async circuitSave() {
      console.log('@@@@@@@ this.content', !this.content)
      let saveFileList = []
      let validCnt = 0
      if (!this.$refs.imgCellFileManage && !this.content && (this.fileList.insert.length === 0 || this.fileList.delete.length === 0)) {
        this.vSnackbar(this.$t('저장할 데이터가 없습니다.'), 'warn')
        return
      }
      if (this.$refs.imgCellFileManage) {
        this.$refs.imgCellFileManage.forEach((el, index) => {
          // 이미지 셀 컴포넌트를 순회하면서 저장된 이미지 파일 정보 호출
          if (el.imgPreview != null && Object.keys(el.imgPreview).length > 0) saveFileList.push(el.newFile)
          else validCnt++
        })
        if (validCnt > 0) {
          this.vToastify(this.$t('저장 입력 항목을 확인해주세요.'), 'info')
          return
        }
      }
      // 데이터 가공
      this.content = this.content === '' ? null : this.content
      this.data00003[0].content = this.content
      if (!this.data00003[0].esgHrNo)
        (this.data00003[0].esgHrNo = this.circuitSafetyList.length > 0 ? this.circuitSafetyList[0].esgHrNo : this.myHrNo),
          console.log('saveFileListsaveFileListsaveFileList', saveFileList)
      let deleteList = this.data00001
        .concat(this.data00002)
        .concat(this.data00003)
        .filter((el) => el.__deleted__)
      console.log('#### deleteList ==> ', deleteList)
      let saveList = this.data00001
        .concat(this.data00002)
        .concat(this.data00003)
        .filter((el) => !el.__deleted__)
      console.log('####  saveList  ==> ', saveList)
      let saveSuccess = false
      this.vToastifyPrompt(
        this.$t('doSaveData'),
        'info',
        async (current) => {
          let deleteParams = {
            clntId: this.getClntId(),
            compId: this.getCompId(),
            writeDt: this.searchStartDate,
            dataList: deleteList,
            __created__: this.circuitCreated,
          }

          let saveParams = {
            clntId: this.getClntId(),
            compId: this.getCompId(),
            writeDt: this.searchStartDate,
            esgHrNo: this.circuitSafetyList.length > 0 ? this.circuitSafetyList[0].esgHrNo : this.myHrNo,
            dataList: saveList,
            __created__: this.circuitCreated,
          }
          if (deleteList.length > 0) {
            this.openLoading()
            await deleteCircuitTaskSafetyInspection(deleteParams, true)
              .then((res) => {
                if (res.success) {
                  this.$refs.imgCellFileManage[0].btnDelete(deleteList) // 셀에 저장된 이미지 삭제
                }
              })
              .catch((err) => {
                this.endLoading()
              })
              .finally(() => {
                this.endLoading()
              })
          }
          // if (this.circuitSafetyList.length < 1 && this.deletedList.length < 1) {
          //   notify(this.$t('저장할 데이터가 없습니다.'), 'error', 1000)
          //   return
          // }
          let saveFileList = []
          let data00001Seq =
            this.data00001.filter((el) => !el.__created__).length === 0 ? 1 : this.data00001.filter((el) => !el.__created__).length + 1
          let data00002Seq =
            this.data00002.filter((el) => !el.__created__).length === 0 ? 1 : this.data00002.filter((el) => !el.__created__).length + 1
          if (this.$refs.imgCellFileManage) {
            this.$refs.imgCellFileManage.forEach((el, index) => {
              // 이미지 셀 컴포넌트를 순회하면서 저장된 이미지 파일 정보 호출
              if (Object.keys(el.newFile).length > 0) {
                let targetSeq = el.newFile.targetId.split('_')
                if (targetSeq[targetSeq.length - 2] === '00001') {
                  targetSeq[targetSeq.length - 1] = data00001Seq.toString()
                  data00001Seq++
                } else if (targetSeq[targetSeq.length - 2] === '00002') {
                  targetSeq[targetSeq.length - 1] = data00002Seq.toString()
                  data00002Seq++
                }
                el.newFile.targetId = targetSeq.join('_')
                saveFileList.push(el.newFile)
              }
            })
          }
          console.log('## saveFileList', saveFileList)
          this.openLoading()
          await saveCircuitSafetyInspection(saveParams, true)
            .then((res) => {
              if (res.success) {
                //
                saveSuccess = true
                if (this.$refs.imgCellFileManage) this.$refs.imgCellFileManage[0].btnSave(saveFileList)
              }
            })
            .catch((err) => {
              this.endLoading()
            })
            .finally(() => {
              if (saveSuccess && (this.fileList.insert.length !== 0 || this.fileList.delete.length !== 0)) {
                this.$refs.iFileUploader_circuit.btnSave(this.fileList)
                this.fileList = {
                  insert: [],
                  delete: [],
                }
              }
              setTimeout(() => {
                this.circuitSearch()
              }, 2000)
              // this.btnSearch()
              this.circuitCreated = false
              this.endLoading()
            })
        },
        null,
        true
      )
    },
    btnDelete() {
      if (this.selectedKey === 0) {
        if (this.dailyCheckList.length === 0) {
          this.vSnackbar(this.$t('삭제할 일일 안전점검 항목이 없습니다.'), 'warn')
          return
        }
        this.vToastifyPrompt(this.$t('doDeleteData'), 'info', async (current) => {
          this.$refs.iFileUploader.fileRemove(this.$refs.iFileUploader.files)
          this.openLoading()
          let deleteData = {
            clntId: this.getClntId(),
            compId: this.initCompId,
            dataDiv: this.dailyCheckList[0].length === 0 ? '' : this.dailyCheckList[0].dataDiv,
            writeDt: this.searchStartDate,
          }
          deleteSafetyInspection(deleteData, true)
            .then((res) => {
              if (res.success) {
                this.endLoading()
                this.hour = 3
                this.minute = 30
                this.worktime = 210
                console.log('#############')
                this.dailyCheckList = []
              }
            })
            .finally(() => {
              this.btnSearch()
              this.endLoading()
            })
        })
      } else if (this.selectedKey === 1) {
        console.log(this.data00001.length, this.data00002.length, this.data00003.length)
        if (this.data00001.length < 1 && this.data00002.length < 1 && !this.content) {
          notify(this.$t('삭제할 데이터가 없습니다.'), 'error', 1000)
          return
        }
        this.vToastifyPrompt(this.$t('doDeleteData'), 'info', async (current) => {
          this.openLoading()
          let deleteList = this.data00001.concat(this.data00002).concat(this.data00003)
          let deleteParams = {
            clntId: this.getClntId(),
            compId: this.getCompId(),
            writeDt: this.searchStartDate,
            dataList: deleteList,
            __created__: this.circuitCreated,
          }
          //삭제 api
          deleteCircuitSafetyInspection(deleteParams, true)
            .then((res) => {
              if (res.success) {
                this.endLoading()
                this.content = ''
                this.data00001 = []
                this.data00002 = []
                this.data00003 = []
                this.$refs.iFileUploader_circuit.fileRemove(this.$refs.iFileUploader_circuit.files)
                this.$refs.imgCellFileManage[0].btnDelete(deleteList) // 셀에 저장된 이미지 삭제
              }
            })
            .finally(() => {
              this.btnSearch()
              this.endLoading()
            })
        })
      }
    },
    btnPrint(type) {
      console.log('####### dailyCheckList', this.dailyCheckList)
      if (this.selectedKey === 0) {
        if (this.dailyCheckList.length === 0 || this.dailyCheckList.filter((el) => el.safetyInspectionDailyYn != null).length === 0) {
          this.vSnackbar(this.$t('출력할 일일 안전점검 항목이 없습니다.'), 'warn')
          return
        }
        if (!this.dailyCheckList[0].writeDt) {
          this.vSnackbar(this.$t('데이터 저장 후 출력이 가능합니다.'), 'warn')
          return
        }
        this.openLoading()
        let searchParams = {
          clntId: this.getClntId(),
          compId: this.getCompId(),
          compNm: this.getCompNm(),
          writeDt: this.searchStartDate,
          type: type,
        }
        console.log('this.dailyCheckList', this.dailyCheckList)
        //PDF 출력 api
        getRptSafetyInspection(searchParams)
          .then((res) => {
            this.downloadReport(res)
          })
          .catch((error) => {
            this.endLoading()
          })
          .finally(() => {
            this.endLoading()
          })
      } else if (this.selectedKey === 1) {
        if (!this.$refs.imgCellFileManage && !this.data00003[0].content) {
          this.vSnackbar(this.$t('출력할 순회 안전점검 항목이 없습니다.'), 'warn')
          return
        }
        this.openLoading()
        let searchParams = {
          clntId: this.getClntId(),
          compId: this.getCompId(),
          compNm: this.getCompNm(),
          writeDt: this.searchStartDate,
          type: type,
        }
        //PDF 출력 api
        getRptCircuitSafetyInspection(searchParams)
          .then((res) => {
            this.downloadReport(res)
          })
          .catch((error) => {
            this.endLoading()
          })
          .finally(() => {
            this.endLoading()
          })
      }
    },

    ///////////////////////////////////////
    /*             etc Event             */
    ///////////////////////////////////////
    downloadReport(res) {
      let link = document.createElement('a')
      // 객체를 만들어서 생성
      let objectUrl = window.URL.createObjectURL(res.data)
      link.href = objectUrl
      link.download = res.headers.filename
      link.click()
    },
    onFileChanged(fileList) {
      this.fileList = fileList
    },
    /**
     * 👉 check agree
     */
    checkAgree(param) {
      this.dailyCheckList.forEach((el) => {
        if (param.__created__ === el.__created__) {
          el.__created__ = true
        }
      })
    },
    worktimeChanged(e) {
      let minute = parseInt(this.hour * 60) + parseInt(this.minute)
      if (minute < 210) {
        this.vSnackbar(this.$t(this.noticeInfo), 'warn')
        this.hour = 3
        this.minute = 30
        this.worktime = 210
        return
      }
      if (this.hour > 23) {
        this.hour = 23
        return
      }
      if (this.minute > 59) {
        this.minute = 59
        return
      }
      this.worktime = minute
    },
  },
}
</script>

<style lang="scss" scoped>
.tableTitle {
  width: 15%;
}

.v-data-table {
  border: 1px solid grey;
}

.tg {
  width: 100%;
  border-collapse: collapse;
  border-spacing: 0;
  margin-bottom: 20px;
}
.tg td {
  border-color: black;
  border-style: solid;
  border-width: 1px;
  font-family: Arial, sans-serif;
  font-size: 14px;
  overflow: hidden;
  padding: 10px 5px;
  word-break: normal;
}
.tg th {
  border-color: black;
  border-style: solid;
  border-width: 1px;
  font-family: Arial, sans-serif;
  font-size: 14px;
  font-weight: normal;
  overflow: hidden;
  padding: 10px 5px;
  word-break: normal;
}
.tg .tg-llyw {
  background-color: #c0c0c0;
  border-color: inherit;
  text-align: left;
  vertical-align: top;
}
.tg .tg-0pky {
  border-color: inherit;
  text-align: left;
  vertical-align: top;
}
</style>
